<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div *ngIf="producto.indicadorComercializacionOficinas" class="text-center" style="color: red;">
    <label>{{ 'PRODUCTOCUESTIONARIO.MSG_NOSEPUEDECONFIGURAR' | translate }}</label>
  </div>

  <p-panel *ngIf="!producto.indicadorComercializacionOficinas" header="{{ 'PRODUCTOCUESTIONARIO.LBL_PRODUCTOCUESTIONARIOS' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioCuestionarios" name="nomFormularioCuestionarios">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOCUESTIONARIO.LBL_CUESTIONARIO' | translate }}</label>
            <div *ngIf="!proCuestionarioSeleccionado">
              <p-dropdown disableTab  id="idCuestionario" name="nomCuestionario" [options]="lisCuestionarios"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                           formControlName="idCuestionario"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCuestionario.invalid">
                {{ 'PRODUCTOCUESTIONARIO.LBL_CUESTIONARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
            <div *ngIf="proCuestionarioSeleccionado && proCuestionarioSeleccionado.idProductoCuestionario">
              <label class="falso-combo-texto">{{proCuestionarioSeleccionado.nombreCuestionario}}</label>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <label>* {{ 'PRODUCTOCUESTIONARIO.LBL_ESTADOCALIFICACION' | translate }}</label>
            <p-dropdown disableTab  id="idEstado" name="nomEstado" [options]="lisEstados"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idEstado"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
              {{ 'PRODUCTOCUESTIONARIO.LBL_ESTADOCALIFICACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <label>* {{ 'PRODUCTOCUESTIONARIO.LBL_CAUSAL' | translate }}</label>
            <p-dropdown disableTab  id="idCausal" name="nomCausal" [options]="lisCausales"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idCausal"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCausal.invalid">
              {{ 'PRODUCTOCUESTIONARIO.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <p-fieldset legend="{{ 'PRODUCTOCUESTIONARIO.LBL_PONDERACIONALIADO' | translate }}">
            <div class="grid">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PRODUCTOCUESTIONARIO.LBL_CONCEPTOMALO' | translate }}</label>
                  <input type="text" pInputText id="idConceptoMalo"
                         name="nomConceptoMalo"
                         autocomplete="off"
                         formControlName="ponderacion"
                         [maxlength]="5"
                         porcentaje-reactive [decimales]="2"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.ponderacion.invalid">
                    {{ 'PRODUCTOCUESTIONARIO.LBL_CONCEPTOMALO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>{{ 'PRODUCTOCUESTIONARIO.LBL_CONCEPTOBUENO' | translate }}</label>
                  <label class="falso-combo-texto">{{f.ponderacion.value}}</label>
                </div>
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                      id="indicador"
                      name="nomIndicador"
                      formControlName="indicadorHabilitado"></p-checkbox>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando"
                 [value]="lisProductosCuestionarios" selectionMode="single" dataKey="idProductoCuestionario"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreCuestionario}}</td>
              <td>{{row.ponderacion}}</td>
              <td>{{row.nombreEstado}}</td>
              <td>{{row.causal}}</td>
              <td>{{row.ponderacion}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="cuestionarios">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
